import React, { FC, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Classification, ClassificationRequest, ResponseData } from "../../../../../models";
import TextInput from "../../shared/fields/textInput";
import SettingsFormInfo from "../../shared/settingsFormInfo";
import SettingsTitle from "../../shared/settingsTitle";
import { putSetting } from "../../../../../services/put.data.service";
import { postSetting } from "../../../../../services/post.data.service";
import SettingsSubmitButton from "../../shared/settingsSubmitButton";

type Props = {
  isDuplicate: (fieldToCheck: keyof Classification, value: string)=> boolean;
  existingClassification?: Classification;
  load: ()=>void;
};

const ClassificationForm: FC<Props> = ({ isDuplicate, existingClassification, load }) => {
  const [redirect, setRedirect] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [errors, setErrors] = useState<string[]>([]);

  useEffect(() => {
    if (existingClassification) {
      setName(existingClassification.name);
    }
  }, [existingClassification]);

  const validate = (): string[] => {
    const errorMessages: string[] = [];
    if (name.length === 0) {
      errorMessages.push("Name is required");
    } else {
      if (isDuplicate("name", name)) {
        errorMessages.push("Name has already been used");
      }
    }
    return errorMessages;
  };

  const handleSaveResponse = (result: ResponseData<ClassificationRequest>): void => {
    if (result.success) {
      load(); 
      setRedirect(true);
    } else {
      setErrors([`Failed to update. ${result.message || result}`]);
    }
  };

  const save = async (): Promise<void> => {
    const errorMessages = validate();
    setErrors(errorMessages);
    if (!errorMessages.length) {
      const toSave: ClassificationRequest = {
        name: name.trim(),
      };
      if (existingClassification) {
        return putSetting<ClassificationRequest>("classifications", existingClassification.classificationId, toSave)
        .then((result: ResponseData<ClassificationRequest>) => {
          handleSaveResponse(result);
        });
      } else {
        return postSetting<ClassificationRequest>("classifications", toSave)
        .then((result: ResponseData<ClassificationRequest>) => {
          handleSaveResponse(result);
        });
      }
    }
  };

  if (redirect) return <Redirect to="/settings/classifications/list" />;

  return (
    <>
      <SettingsTitle errors={errors} title={existingClassification ? "Edit Classification" : "Create Classification"}>
        <SettingsSubmitButton onSave={save} />
      </SettingsTitle>
      <div className="row">
        <SettingsFormInfo existingTitle={existingClassification?.name} >
        </SettingsFormInfo>
        <div className="col-sm-7">
          <div className="content-container p-3">
            <TextInput 
              label="Name" 
              name="classification-name" 
              onChange={setName} 
              value={name} 
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default ClassificationForm;
